export const validarTelefone = (telefone: string): boolean => {

    const telefoneLimpo = telefone.replace(/\D/g, '');

    if (!/^\d+$/.test(telefoneLimpo)) {
        return false;
    }

    // Validar comprimento (10 ou 11 dígitos)
    if (telefoneLimpo.length !== 10 && telefoneLimpo.length !== 11) {
        return false;
    }

    // Não permitir telefone com todos os dígitos zero
    if (telefoneLimpo === '0'.repeat(telefoneLimpo.length)) {
        return false;
    }

    // Validação de DDD
    const ddd = parseInt(telefoneLimpo.substring(0, 2), 10);
    if (ddd < 11 || ddd > 99) {
        return false;
    }

    // Se tiver 11 dígitos (celular), o terceiro dígito deve ser 9
    if (telefoneLimpo.length === 11) {
        const terceiroDigito = telefoneLimpo[2];
        if (terceiroDigito !== '9') {
            return false;
        }
    }

    return true;
}